import { whenMountReady } from "#ce/framework/mount-ready";

const selector = '[data-behaviour~="canonical-update"]';

document.addEventListener("click", async (event) => {
  const trigger = event.target.closest(selector);
  if (!trigger) {
    return;
  }

  event.preventDefault();

  const modal = document.querySelector("sp-canonical-update-app");
  if (!modal) {
    return;
  }

  try {
    await whenMountReady(modal);
  } catch (error) {
    console.error("sp-canonical-update-app failed to load; the Update from Canonical modal is unavailable", error);
    return;
  }

  modal.open();
});
